import styled from "styled-components";
import { colors } from '../../shared';

export const GroupContainer = styled.div`
    display: inline-flex;
    border-radius: 0.25rem;
`;

export const Button = styled.button`
    cursor: pointer;
    outline: none;
    background-color: ${({ isActive }) => (isActive ? colors.dark : 'transparent')};
    color: ${({ isActive }) => (isActive ? colors.whiteDuplicate : 'inherit')};
    min-width: 2.5rem;
    margin: 0;
    padding: 0.0625rem 1.375rem;
    font-size: 0.8125rem;
    line-height: 1.75;
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 0.25rem;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

    ${({ groupLength }) => groupLength > 1 &&
    ` 
        :first-child{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-right-color: transparent;
        }
        :not(:first-child):not(:last-child){
            border-radius: 0;
            border-right-color: transparent;
        }
        :last-child {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    `
    }
   
    :hover {
        background-color: ${({ isActive }) => (isActive ? colors.dark : colors.veryLightPinkTwoDuplicate)};
        color: ${({ isActive }) => (isActive ? colors.whiteDuplicate : colors.darkTwo)};
    }
`;

export const Label = styled.span`
    width: 100%;
    display: inherit;
    align-items: inherit;
    justify-content: inherit;
`;
